import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from './../../shared';
import { BlogPage } from  './../blog-page';

@Component({
  selector: 'dbh-integrates-linescape-schedules',
  template: require('./dbh-integrates-linescape-schedules.component.html'),
  styles: [require('./../blog.component.scss'), require('./dbh-integrates-linescape-schedules.component.scss')]
})
export class DbhIntegratesLinescapeComponent extends BlogPage {
  title = "dbh Integrates Linescape Sailing Schedules - Linescape";
  description = "Bremen ports Ship Information System (SIS) extended by worldwide sailing lists";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/dbh-integrates-linescape-schedules/dbh-integrates-linescape-schedules.component.ts